import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Filters,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import { WebService } from '../web/web.service';
import { PromptAI } from './prompt-ai.service';

@Injectable({
  providedIn: 'root',
})
export class PromptAIWebService {
  private readonly _nomeWs = 'prompt-ai';
  constructor(private readonly _webService: WebService) {}

  /**
   * Aggiorna un prompt esistente con un nuovo valore.
   *
   * @param {string} idPrompt - L'ID del prompt da aggiornare.
   * @param {string} prompt - Il nuovo valore del prompt da impostare.
   */
  updatePrompt(PromptAI: PromptAI): Observable<any> {
    return this._webService.doPut('/api/v1/' + this._nomeWs + '/update', PromptAI, {
      id: PromptAI.id,
    });
  }

  /**
   * Salva un nuovo prompt.
   *
   * @param {PromptAI} promptAI - L'oggetto che contiene i dati del prompt da salvare.
   */
  public salvaPrompt(promptAI: PromptAI): Observable<any> {
    return this._webService.doPost('/api/v1/' + this._nomeWs, promptAI);
  }

  /**
   * Recupera un prompt tramite ID elemento e tipo.
   *
   * @param {string} idElemento - L'ID dell'elemento per cui si desidera recuperare il prompt.
   * @param {string} tipo - Il tipo del prompt da cercare (ad esempio, 'text', 'image', ecc.).
   */
  public getPromptByIdTipoElem(idElemento: string, tipo: string) {
    return this._webService.doGet(
      '/api/v1/' + this._nomeWs + '/elemento/' + idElemento + '/tipo/' + tipo,
      {},
    );
  }

  /**
   * Recupera una lista di prompt con opzioni di paginazione, ricerca, filtri e ordinamento.
   *
   */
  public listaPrompt(
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ): Observable<any> {
    return this._webService.doPost('/api/v1/' + this._nomeWs + '/list', {
      page,
      pageSize,
      ricerca,
      filters,
      sortBy,
    });
  }
}
